import { useState } from 'react'
import { HeadingBlockComponent } from '../../../components/ui/heading.block.component'
import { ProcessStepsContainer } from '../process.steps.component/styled'
import * as styled from './styled'

const categories = [
	'Благоустрій прибудинкової території',
	'Магістральні водоводи зовнішніх мереж',
	'Експлуатація і ремонт житлового фонду',
	'Ліфтове господарство',
	'Інженерні мережі',
	'Ремонт та утримання доріг',
	'Колодязі і відкриті люки',
	'Подяки',
	'Транспорт',
	'Надання довідкової інформації',
	'Благоустрій. Загальні питання',
	'Охорона навколишнього середовища',
	'Благоустрій вулично-шляхової мережі',
	'Інші питання ЖКГ',
	'Служба обслуговування електромереж',
	'Скарги',
	'COVID-19',
	'Благоустрій. Утримання зелених насаджень',
	'Наркотичні речовини',
	'Дослідження в довкіллі факторів, що можуть сприяти на здоров’я',
	'Охорона культурної спадщини',
	'Контроль за дотриманням Правил благоустрою',
	'Комунальні установи та комунальна власність',
	'Надзвичайна ситуація та цивільний захист населення',
	'Охорона та громадська безпека',
	'Інші питання',
]

export const QuestionsListComponent = () => {
	const [expanded, setExpanded] = useState(false)

	return (
		<ProcessStepsContainer>
			<HeadingBlockComponent
				label='З якими питаннями можна звернутися до'
				title='Контакт-Центру'
			/>
			<styled.QuestionsList $expanded={expanded}>
				{categories.map((item, index) => (
					<styled.QuestionItem key={index}>{item}</styled.QuestionItem>
				))}
			</styled.QuestionsList>
			<styled.ShowMoreButton onClick={() => setExpanded(!expanded)}>
				{expanded ? 'Приховати ↑' : 'Показати ще ↓'}
			</styled.ShowMoreButton>
		</ProcessStepsContainer>
	)
}
